import React, { useState } from "react";
import governmentLogo from "../../assets/images/agriculture-logo-dark.png";
import krishimapper from "../../assets/images/krishiMapper.png";
import Profile from "../../assets/images/profile-img.jpg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars, faList } from "@fortawesome/free-solid-svg-icons";
import "./AdminSideBar";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import $ from 'jquery'; 
import { Link } from "react-router-dom";


const MapHeader = () => {
  // function capitalFirstLetter(string) {
  //     return string.charAt(0).toUpperCase() + string.slice(1);
  // }

  const navigate = useNavigate()

  const [oldPassword, setOldPassword] = useState("")
  const [newPassword, setNewPassword] = useState("")
  const [confirmNewPassword, setConfirmNewPassword] = useState("")

  function mySidebarToggle() {
    var element = document.getElementById("myDIV");
    element.classList.toggle("mystyle");
    var element2 = document.getElementById("main");
    element2.classList.toggle("fullDiv");
  }

  function handleChangePassword() {

    if(newPassword !== confirmNewPassword) {
      alert("New Password and Confirm Password does not match");
      return;
    }

    if(window.location.href.includes("inspection")) {
      axios
      .post(
        `${
          process.env.NODE_ENV === "development"
            ? process.env.REACT_APP_DEV_MODE
            : process.env.REACT_APP_PRO_MODE
        }/api/inspectionUsers/inschangePassword`,
        {
          modifiedByUC:  sessionStorage.getItem("userCode"),  
          userId: sessionStorage.getItem("userId"),
          password: oldPassword,
          passwordNew: newPassword,
          passwordConfirm: confirmNewPassword
        }
      )
      .then(function (response) { 
        alert(response.data.message);
        if(response.data.success) {
          // $("#modal").modal('hide');
          $('#changeBtn').on('click', function () {
            $('#changePasswordModel').modal('hide');        
            })
            setOldPassword("")
            setNewPassword("")
            setConfirmNewPassword("")
          navigate("/login");
        }   
      })
      .catch(function (error) {
        console.log(error);
      });

    }else {

    

    axios
      .post(
        `${
          process.env.NODE_ENV === "development"
            ? process.env.REACT_APP_DEV_MODE
            : process.env.REACT_APP_PRO_MODE
        }/api/users/changePassword`,
        {
          userCode: localStorage.getItem("userCodeGlobal"),
          password: oldPassword,
          passwordNew: newPassword,
          passwordConfirm: confirmNewPassword,
          modifiedByUC: localStorage.getItem("userCodeGlobal"),
        }
      )
      .then(function (response) { 
        alert(response.data.message);
        if(response.data.success) {
          // $("#modal").modal('hide');
          $('#changeBtn').on('click', function () {
            $('#changePasswordModel').modal('hide');        
            })
            setOldPassword("")
            setNewPassword("")
            setConfirmNewPassword("")
          navigate("/login");
        }   
      })
      .catch(function (error) {
        console.log(error);
      });}
  }

function handleResetValue() {
  setOldPassword("")
  setNewPassword("")
  setConfirmNewPassword("")
}

  return (
    <>
   
      <div id="header" className="header fixed-top d-flex align-items-center">
        <div className="d-flex align-items-center justify-content-between">
          <i className="toggle-sidebar-btn">
            <FontAwesomeIcon icon={faBars} onClick={mySidebarToggle} />
          </i>

<div className="innerlogo-division">
                                    <img src={governmentLogo} alt="agriculture government of india" className="governmentLogo" />

                                   
                                        <ul>
                                            <li className="krishi_heading" lang="hi">कृषि एवं किसान कल्याण विभाग</li>
                                            <li className="department_heading" lang="en">DEPARTMENT OF AGRICULTURE &amp; FARMERS WELFARE <br /><h6>MINISTRY OF AGRICULTURE &amp; FARMERS WELFARE</h6></li>
                                            <li className="department_heading-tow" lang="en">
                                                {/*<h6 className="logo-text logo-text-one">*/}
                                                {/*    <span>भारत सरकार</span>*/}
                                                {/*    <span>GOVERNMENT OF INDIA</span>*/}
                                                {/*</h6>*/}
                                                <h6 className="logo-text logo-text-two">
                                                    {/*   <span>कृषि एवं किसान कल्याण मंत्रालय</span>*/}
                                                    <span></span>
                                                </h6>
                                            </li>
                                        </ul>

                                   
                                </div>


   {/* <img src={governmentLogo} className="governmentLogo"/> */}
   
   <img src={krishimapper} className="krishimapperLogo"/>
        </div>

        <div className="header-nav ms-auto">
          

        <Link className="btn btn-success gohomebtn" to="/" 
  ><i className="bi bi-house-check-fill"></i> Home</Link>
        <ul className="d-flex align-items-center">

            <li className="nav-item dropdown pe-3">
              

              
              
              
              
              <a
                className="nav-link nav-profile d-flex align-items-center pe-0"
                data-bs-toggle="dropdown"
              >
                <img src={Profile} alt="Profile" className="rounded-circle" />
                {/* <span className="d-none d-md-block dropdown-toggle ps-2">{capitalFirstLetter(sessionStorage.getItem("userId"))}</span> */}
                {window.location.href.includes("inspection") ? (
                  <span className="d-none d-md-block dropdown-toggle ps-2 ">
                    {sessionStorage.getItem("userName")}
                  </span>
                ) : (
                  <span className="d-none d-md-block dropdown-toggle ps-2">
                    {localStorage.getItem("username")}
                  </span>
                )}
              </a>

              {window.location.href.includes("inspection") ? (
                <ul className="dropdown-menu dropdown-menu-end dropdown-menu-arrow profile inspectionDrop">
              
                
                      <li > 

                      <a
                      className="dropdown-item d-flex align-items-center"
                      href="#"
                    >
                    
                    <span
                      type="button"
                      // className="dropdown-item d-flex btn-info"
                      data-bs-toggle="modal"
                      data-bs-target="#changePasswordModel"              
                    >                  
                     Change Password
                    </span>
                    </a>
                  </li>

                  <li>
                    <a
                      className="dropdown-item d-flex align-items-center"
                      href="#"
                    >
                      
                      <span
                        onClick={() => {
                          sessionStorage.removeItem("user");
                        }}
                      >
                        Sign Out
                      </span>
                    </a>
                  </li>
                </ul>
              ) : (
                <ul className="dropdown-menu dropdown-menu-end dropdown-menu-arrow profile">
                  <li className="dropdown-header">
                    {/* <h6>{capitalFirstLetter(localStorage.getItem("username"))}</h6>   */}
                    <h6>{localStorage.getItem("username")}</h6>
                  </li>
                  
                  <li style={{backgroundColor : "F0F0F0"}}>
                    {/* <a className="dropdown-item d-flex align-items-center" href="#"> */}
                  
                    {/* <span onClick={handleChangePassword}>Change Password</span> */}
                    <span
                      type="button"
                      className="dropdown-item d-flex btn-info"
                      data-bs-toggle="modal"
                      data-bs-target="#changePasswordModel"
                      // onClick={handleChangePassword}
                      
                    >
                     
                     Change Password
                    </span>
                    {/* </a> */}
                  </li>
                  <li>
                    <a
                      className="dropdown-item d-flex align-items-center"
                      href="#"
                      style={{backgroundColor : "F0F0F0"}}
                    >
                    
                      <span 
                        onClick={() => {
                          sessionStorage.removeItem("user");
                        }}
                      >
                        Logout
                      </span>
                    </a>
                  </li>
                </ul>
              )}
            </li>
          </ul>
        </div>
      </div>

      <div className="modal" id="changePasswordModel">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
             <strong> Change Password</strong>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                onClick={handleResetValue}
              >X</button>
            </div>

            <div className="modal-body">
              {/* <label for="add_season" className="form-label">
                Add New User Type
              </label> */}
              Old Password
              <input
                type="password"
                className="form-control"
                
                // placeholder="Old Password "
                onChange={(e) => setOldPassword(e.target.value)}
                value = {oldPassword}
              />
              New Password
               <input
                type="password"
                className="form-control"
                // placeholder="New Password"
                onChange={(e) => setNewPassword(e.target.value)}
                 value={newPassword}
              />
              Confirm New Password
               <input
                type="password"
                className="form-control"
                // placeholder="Confirm New Password"
                onChange={(e) => setConfirmNewPassword(e.target.value)}
                value={confirmNewPassword}
              />
            </div>

            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-success"
                id="changeBtn"
                //  data-bs-dismiss="modal"
                 onClick={handleChangePassword}
              >
                Change
              </button>
              <button
                type="button"
                className="btn btn-danger"
                data-bs-dismiss="modal"
                onClick={handleResetValue}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MapHeader;
